import { call, takeLatest, all, put, select } from 'redux-saga/effects';
import api from 'services/api';

import { Types, Creators } from 'store/ducks/groupChild/list';
import { callApi } from 'store/sagas/auth';
import Notifications from 'react-notification-system-redux';

function* getGroupChildList({ payload }) {
  try {
    const { page, perPage, search, orderByColumn, orderByDirection } = payload;
    const request = call(api.get, '/v1/admin/children/groups', {
      page,
      search,
      per_page: perPage,
      order: orderByColumn,
      order_by: orderByDirection,
    });

    const response = yield call(callApi, request);
    yield put(Creators.getGroupChildListSuccess(response.data));
  } catch (err) {
    if (err.status === 404) {
      yield put(
        Creators.getGroupChildListSuccess({
          total: 0,
          data: [],
        }),
      );
    } else {
      yield put(Creators.getGroupChildListFailure('Erro ao buscar na API'));
    }
    yield put(Notifications.error({ title: err.data.msg }));
  }
}

// Individual exports for testing
export default function* productListSaga() {
  yield all([
    takeLatest(Types.GET_LIST_REQUEST, getGroupChildList),
  ]);
}
